<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <topPiece></topPiece>
      <div class="container">
        <titleConfig
          :title="langSet == 'cn' ? 'FDI WDC 2025展位图' : 'FDI WDC 2025展位图'"
          :type="2"
        ></titleConfig>
        <div class="floor_wrap">
          <div class="title">2025 FDI世界口腔医学大会</div>
          <div class="sub_title">2025年9月9-12日 国家会展中心(上海)</div>
          <div class="floor_btn">获取展位图</div>
          <div class="floor_list">
            <contacts :list="list"></contacts>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import topPiece from "../../components/topPiece.vue";
import titleConfig from "../../components/title.vue";
import contacts from "../../components/contacts.vue";
// import { webAbout, webExhibitionType, getWebsite } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    topPiece,
    titleConfig,
    contacts,
  },
  data() {
    return {
      langSet: "",
      list: [
        {
          name: "陈苏苏 女士",
          name_en: "susu",
          landline: "+86 10 8455 6618",
          mobile: "+86 186 1161 0929",
          email: "susu.chen@com",
        },
        {
          name: "陈苏苏 女士",
          name_en: "susu",
          landline: "+86 10 8455 6618",
          mobile: "+86 186 1161 0929",
          email: "susu.chen@com",
        },
        {
          name: "陈苏苏 女士",
          name_en: "susu",
          landline: "+86 10 8455 6618",
          mobile: "+86 186 1161 0929",
          email: "susu.chen@com",
        },
      ],
      metaData: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
  },
};
</script>
<style lang="scss" scoped>
.floor_wrap {
  font-size: 20px;
  color: #000000;
  line-height: 28px;
  padding: 40px 0 100px;
  .title {
    font-weight: 500;
    font-size: 24px;
    color: #000000;
    line-height: 33px;
    text-align: center;
  }
  .sub_title {
    text-align: center;
    margin: 10px 0 30px;
  }
  .floor_btn {
    width: 480px;
    height: 68px;
    color: #fff;
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    line-height: 68px;
    cursor: pointer;
    margin: 0 auto 60px;
    background: url("../../assets/imgs/btn_bg.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 10px;
  }
}
@media only screen and (max-width: 1280px) {
}
@media only screen and (max-width: 767px) {
}
</style>